import { NoPhotography } from '@mui/icons-material'
import { ButtonBase, Card, CircularProgress, Grid, Theme, Typography } from '@mui/material'
import * as controllers from 'controllers'
import { useEffect, useState } from 'react'

interface ClusterShippersThirdPartyConversionDeliveryImageCardProps {
  complete?: boolean
  disabled?: boolean
  fileName?: string
  onClick?: () => void
  clusterShipperGuid?: string
}

export default function ClusterShippersThirdPartyConversionDeliveryImageCard({
  complete,
  disabled,
  fileName,
  onClick,
  clusterShipperGuid
}: ClusterShippersThirdPartyConversionDeliveryImageCardProps) {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [photoFileBase64, setPhotoFileBase64] = useState<string>('')
  const [format, setFormat] = useState<string>('')

  const getColor = (theme: Theme): string => {
    if (disabled) {
      return theme.palette.grey[400] // '#b0a8b9'
    } else if (complete) {
      return theme.palette.success.main // '#009c45'
    }
    return theme.palette.error.main // '#ff0000'
  }

  useEffect(() => {
    if (fileName && clusterShipperGuid) {
      setFormat(fileName.split('.')[fileName.split('.').length - 1])
      setIsLoading(true)
      controllers
        .getClusterShipperThirdPartyConversionDeliveryPhotoBase64(clusterShipperGuid, fileName)
        .then(base64 => {
          setPhotoFileBase64(base64)
        })
        .finally(() => {
          setIsLoading(false)
        })
    } else {
      setPhotoFileBase64('')
    }
  }, [fileName, clusterShipperGuid])

  return (
    <Card
      component={ButtonBase}
      onClick={onClick}
      sx={theme => ({
        backgroundColor: getColor(theme),
        color: '#fff',
        p: 1,
        width: '220px'
      })}
    >
      <Grid container spacing={0} alignItems='center' justifyContent='center'>
        <Grid item sx={{ minHeight: 84.375, maxHeight: 84.3755 }}>
          {isLoading && <CircularProgress sx={{ color: '#fff', mt: 5 }} />}
          {!isLoading && photoFileBase64 && (
            <img
              alt={'3rd Party Conversion Delivery'}
              src={`data:image/${format};base64,${photoFileBase64}`}
              width={150}
              id={fileName}
              height={84.375}
            />
          )}
          {!isLoading && !photoFileBase64 && <NoPhotography fontSize='large' sx={{ height: 84.375 }} />}
        </Grid>

        <Grid item xs={12}>
          <Typography align='center' variant='body2'>
            3rd Party Conversion Delivery
          </Typography>
        </Grid>
      </Grid>
    </Card>
  )
}
